module.exports = __webpack_public_path__ + "static/media/location-rojo.57a33959.svg";